/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'credentials-verification';
const prefix = `${moduleName}.${componentName}`;

export const changeCredentialsButtonLabel = `${prefix}.changeCredentialsButtonLabel`;

export const ENGLISH = {
    [changeCredentialsButtonLabel]: 'Change Credentials',
};
